const PREFIX_MODE = {
    payee: 'text',
    payer: 'text',
    ref: 'text',
    amount: 'amount',
};
const FIELD_BY_PREFIX = {
    payee: 'payee',
    payer: 'payer',
    ref: 'ref',
};
/**
 * Parses optional `prefix:value` search syntax. Unknown prefixes fall back to full string as text.
 * Shared by web payments UI and api-server payment list handling.
 */
export function parsePrefixedSearch(raw) {
    const match = raw.match(/^(\w+):(.+)$/);
    if (match) {
        const [, prefix, value] = match;
        const p = prefix.toLowerCase();
        const mode = PREFIX_MODE[p];
        if (mode === 'amount')
            return { mode: 'amount', value: value.trim() };
        if (mode === 'text') {
            const searchField = FIELD_BY_PREFIX[p];
            return { mode: 'text', value: value.trim(), searchField };
        }
    }
    return { mode: 'text', value: raw.trim() };
}
//# sourceMappingURL=parse-prefixed-search.js.map